import React, { useEffect, useState } from "react"
import { Avatar } from "@mui/material"

interface Props {
  onClick?: () => void
  uid: string | null
  url: string | null
  alt: string
  size: number
  children?: React.ReactNode
}
const CMCAvatar: React.FC<Props> = ({ children, onClick, uid, url, alt, size }) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(url)

  useEffect(() => {
    setAvatarUrl(url)
  }, [url])

  return (
    <Avatar
      onClick={onClick}
      sx={{ height: size, width: size, border: "1px solid gray" }}
      alt={alt}
      src={avatarUrl || undefined}>
      {children}
    </Avatar>
  )
}
export default CMCAvatar
